// extracted by mini-css-extract-plugin
export default {"goesOnSaleLabel":"g0jQp0","onSaleLabel":"gq_HE4"};